import React from 'react';
import MainLayout from '../components/MainLayout';
import '../styles/global.css'


const HomePage: React.FC = () => {
  return (
    <MainLayout>
      <div className="container mx-auto py-10 px-6">
        <h1 className="text-4xl font-bold text-gray-800 mb-6">Welcome to the Announcement Tool</h1>
        <p className="text-lg text-gray-600 mb-4">
          This tool allows you to send important announcements and service updates to stakeholders via email. You can easily create announcements, customize distribution lists, and ensure that the right recipients are notified about any changes or updates. Stay connected and keep your team informed with just a few simple steps.
        </p>
        <p className="text-lg text-gray-600 mb-8">
          Use this platform to manage communication effectively and ensure everyone is up-to-date on the latest changes and service modifications. Additionally, any stakeholders within the Volkswagen Group can also subscribe and manage their announcements via this tool, providing a seamless way to stay informed.
        </p>
      </div>
    </MainLayout>
  );
};

export default HomePage;